import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderReportfield, renderTableTD, renderTableTH} from '../../utils/templateUtils';
import './thirdMonthPregnancy.scss';

export default function ThirdMonthPregnancy(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [showTables, setShowTables] = useState({
    medication: true
  });

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: '1',
      drug: 'T. Furnext / Globac XT/ Ferronomic plus',
      genericName: 'Ferrous bisglycinate + Folic Acid + Zinc + Methylcobalamin',
      dosage: '',
      freq: '0-1-0',
      withFood: 'after food',
      duration: '30 Days'
    },
    {
      sno: '2',
      drug: 'C. Folvista / Intafol D',
      genericName: 'L-Methylfolate + Methylcobalamin + Pyridoxal-5-Phosphate',
      dosage: '1 cap',
      freq: '0-1-0',
      withFood: 'Ater food',
      duration: '30 days'
    },
    {
      sno: '3',
      drug: 'T. Tricium XT',
      genericName: 'Calcium Citrate + Vitamin D3 + Zinc + Magnesium',
      dosage: '',
      freq: '1-0-1',
      withFood: 'After food',
      duration: '30 days'
    },
    {
      sno: '4',
      drug: 'T. Thyronorm ___ mcg',
      genericName: 'Levothyroxine Sodium',
      dosage: '',
      freq: '1-0-0',
      withFood: 'Early morning empty stomach',
      duration: 'Daily'
    },
    {
      sno: '5',
      drug: 'T. Glycomet ___ mg',
      genericName: 'Metformin Hydrochloride',
      dosage: '1 tab',
      freq: 'As advised',
      withFood: 'With food',
      duration: 'Daily'
    },
    {
      sno: '6',
      drug: 'Inj. Td VAC',
      genericName: 'Tetanus and Diphtheria Vaccine',
      dosage: '0.5 ml IM',
      freq: '-',
      withFood: '-',
      duration: '1st dose –\n2nd dose –\nBoostrix @ 27–36 weeks'
    },
    {
      sno: '7',
      drug: 'Viva Mom',
      genericName: 'Protein Powder with DHA, Vitamins, Minerals',
      dosage: '2 tsp',
      freq: 'Morning & Evening',
      withFood: 'With milk',
      duration: '1 box'
    },
    {
      sno: '8',
      drug: 'T. CVit',
      genericName: 'Ascorbic Acid (Vitamin C)',
      dosage: '',
      freq: '0-1-0',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '9',
      drug: 'T. Neuroplex',
      genericName: 'Multivitamin B-complex with Vitamin C',
      dosage: '',
      freq: '0-0-1',
      withFood: 'After food',
      duration: '30 Days'
    },
    {
      sno: '10',
      drug: 'INJ INFLUVAC TETRA',
      genericName: 'INACTIVATED INFLUENZA VACCINE(QUADRIVALENT)',
      dosage: '1 AMP IM',
      freq: 'STAT',
      withFood: '-',
      duration: '-'
    },
    {
      sno: '11',
      drug: 'Tab. Ecosprin 75/150',
      genericName: 'Aspirin 75/150 mg',
      dosage: '1 tablet',
      freq: '0-0-1',
      withFood: 'in the night after meal',
      duration: 'Till 34 weeks'
    }
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Drug'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dosage'},
    {key: 'freq', label: 'Frequency'},
    {key: 'withFood', label: 'Timing'},
    {key: 'duration', label: 'Duration'}
  ];

  const handleChange = e => {
    var text = e.target.value;

   if (e.target.name === 'patientId') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId') {
              setFormData({
                ...formData,
                patientName: namePat,
                age: data?.age,
                gender: data?.gender,
                patientId: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId') {
          setFormData({
            ...formData,
            patientId: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
   setshow(true);
              setTimeout(async () => {
          const htmlPayload = document.getElementById('thirdMonthPregnancyReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Spontaneous Pregnancy - 3 Month'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='ThirdMonthPregnancyTemplate'>
      <div className='ThirdMonthPregnancyTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>3rd Month / NT Scan Visit Summary</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='POG:' name='pog' value={formData.pog} required={false} onChange={handleChange} inputClassName='show' endLabel='weeks' />
            </div>
          </div>
          <h3 className='mt-3'>NT Scan:</h3>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='NT:' name='nt' value={formData.nt} required={false} onChange={handleChange} inputClassName='show' endLabel='mm' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='NB:' name='nb' value={formData.nb} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='TR:' name='tr' value={formData.tr} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='DV:' name='dv' value={formData.dv} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Cervical Length:'
                name='cervicalLength'
                value={formData.cervicalLength}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='cm'
                minWidth='160px'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label htmlFor='dualMarker' className='fw-bold' style={{width: '180px'}}>
              Dual Maker / NIPT / PNGF:
            </label>
            <textarea className='Textarea' placeholder='Options explained' id='dualMarker' name='dualMarker' onChange={handleChange} rows='3' cols='100' />
          </div>

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='complaints' className='fw-bold' style={{width: '180px'}}>
              Complaints:
            </label>
            <textarea className='Textarea' placeholder='Complaints' id='complaints' name='complaints' onChange={handleChange} rows='3' cols='100' />
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Pallor'
                name='pallor'
                value={formData.pallor}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Pedal Edema'
                name='pedalEdema'
                value={formData.pedalEdema}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Pulse:' name='pulse' value={formData.pulse} required={false} onChange={handleChange} inputClassName='show' endLabel='/min' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
          </div>
          <div className='row pb-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Pre-pregnancy weight:'
                name='prePregnancyWeight'
                value={formData.prePregnancyWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='200px'
              />
            </div>
          </div>
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='Medications Prescribed'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='bulletin'>
          <h4>📄 Advice & Instructions</h4>
          <ul className='px-3'>
            <li>
              📄 <strong>Investigations:</strong> Submit Dual Marker report by next visit
            </li>
            <li>
              🏥 <strong>PICME Registration:</strong> Visit nearest govt. hospital with Aadhar + 2 photographs
            </li>
            <li>
              🤰 <strong>Vomiting:</strong> Likely to subside by 14 weeks. Start Iron & Calcium then if needed
            </li>
            <li>
              ⏱️ <strong>Maintain a 4-hour gap between Iron and Calcium</strong>
            </li>
            <li>
              🚫 <strong>Avoid tea, coffee, biscuits near iron intake – reduces absorption</strong>
            </li>
            <li>
              📊 <strong>Double Marker / NIPT:</strong> Give report on NT scan day. Result takes 7–10 days. Review with Dr. Aishwarya
            </li>
            <li>
              📞 <strong>Emergency Contact:</strong> +91-93425 21779
            </li>
            <li>
              🥗 <strong>Follow the 3 meals + 3 snacks diet – collect diet chart from staff</strong>
            </li>
            <li>
              🏃 <strong>Exercise:</strong> You may start walking, yoga, swimming, light cycling/jogging, Zumba
            </li>
            <li>
              📺 <strong>Watch:</strong> <i>Doctor Mommies YouTube – 2nd Trimester Dos and Don’ts.</i>
            </li>
          </ul>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='thirdMonthPregnancyReport'>
        <div id='thirdMonthPregnancyReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '5px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>3rd Month / NT Scan Visit Summary</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('POG:', `${formData.pog ? formData.pog : ''} weeks`)}</div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>NT Scan:</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('NT:', `${formData.nt ? formData.nt : ''} mm`)}
            {renderReportfield('NB:', formData.nb)}
            {renderReportfield('TR:', formData.tr)}
            {renderReportfield('DV:', formData.dv)}
            {renderReportfield('Cervical Length:', `${formData.cervicalLength ? formData.cervicalLength : ''} cm`)}
          </div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Dual Marker / NIPT:', formData.dualMarker)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Complaints:', formData.complaints)}</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pallor:', formData.pallor)}
            {renderReportfield('Pedal Edema:', formData.pedalEdema)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pulse:', `${formData.pulse ? formData.pulse : ''} /min`)}
            {renderReportfield('BP:', `${formData.bp ? formData.bp : ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight ? formData.weight : ''} kg`)}
            {renderReportfield('Pre-pregnancy weight:', `${formData.prePregnancyWeight ? formData.prePregnancyWeight : ''} kg`)}
          </div>

          {showTables.medication && (
            <>
              {' '}
              <div style={{display: 'flex', marginTop: '5px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>Medications Prescribed</h4>
              </div>
              <table
                style={{
                  marginBottom: '5px',
                  border: '1px solid black',
                  width: '100%',
                  textAlign: 'center'
                }}>
                <thead>
                  <tr>{medicationHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {medicationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.drug)}
                      {renderTableTD(row.genericName)}
                      {renderTableTD(row.dosage)}
                      {renderTableTD(row.freq)}
                      {renderTableTD(row.withFood)}
                      {renderTableTD(row.duration)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Advice & Instructions', '', {styleSec: {width: '100%'}})}</div>
          {[
            '📄 Investigations: Submit Dual Marker report by next visit',
            '🏥 PICME Registration: Visit nearest govt. hospital with Aadhar + 2 photographs',
            '🤰 Vomiting: Likely to subside by 14 weeks. Start Iron & Calcium then if needed',
            '⏱️ Maintain a 4-hour gap between Iron and Calcium',
            '🚫 Avoid tea, coffee, biscuits near iron intake – reduces absorption',
            '📊 Double Marker / NIPT: Give report on NT scan day. Result takes 7–10 days. Review with Dr. Aishwarya',
            '📞 Emergency Contact: +91-93425 21779',
            '🥗 Follow the 3 meals + 3 snacks diet – collect diet chart from staff',
            '🏃 Exercise: You may start walking, yoga, swimming, light cycling/jogging, Zumba',
            '📺 Watch: Doctor Mommies YouTube – 2nd Trimester Dos and Don’ts'
          ].map((item, index) => (
            <div key={index} style={{display: 'flex', marginBottom: '5px'}}>
              {/* {renderIndentation()} */}
              {/* {item.startsWith('   ') ? renderIndentation() : renderDiscPoint()} */}
              {renderReportfield(item, '', {styleSec: {width: '100%', marginLeft: item.startsWith('   ') ? '20px' : '0'}})}
            </div>
          ))}

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
  }
